import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Skeleton,
  DialogActions,
} from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { FC } from 'react';
import { IconMapper } from '../../../common/helpers/IconMapper';
import useGetFacilityGroups from '../../../hooks/useGetFacilityGroup';
import { BoatFacilitiesByBoatIdQuery } from '../../../gql/graphql';

interface Props {
  showBoatFacilities: boolean;
  setShowBoatFacilities: (show: boolean) => void;
  isDesktopVersion: boolean;
  boatFacilities: BoatFacilitiesByBoatIdQuery | undefined;
}

const BoatFacilityDialog: FC<Props> = ({
  showBoatFacilities,
  setShowBoatFacilities,
  isDesktopVersion,
  boatFacilities,
}) => {
  const { facilityGroups, facilityGroupsLoading } = useGetFacilityGroups();

  return (
    <Dialog
      open={showBoatFacilities}
      onClose={() => setShowBoatFacilities(false)}
      fullScreen={!isDesktopVersion}
      sx={
        isDesktopVersion
          ? {}
          : {
              height: '90%',
              top: 'unset',
            }
      }
      slotProps={{
        paper: isDesktopVersion
          ? {
              sx: { borderRadius: '1.5rem', width: '800px', maxHeight: '80%' },
            }
          : {
              sx: { borderRadius: '1.5rem 1.5rem 0 0' },
            },
      }}
    >
      {isDesktopVersion ? null : (
        <DialogTitle>
          <div className="flex items-center justify-between">
            <IconButton onClick={() => setShowBoatFacilities(false)}>
              <IconX size={16} />
            </IconButton>
            <span className="font-semibold">Boat features</span>
            <span></span>
          </div>
        </DialogTitle>
      )}
      <DialogContent dividers>
        <div className="flex flex-col items-start gap-6 md:gap-12">
          <div className="hidden justify-between w-full md:flex">
            <span className="text-3xl font-semibold text-neutral-800">
              Boat features
            </span>
            <button onClick={() => setShowBoatFacilities(false)}>
              <IconX size={20} />
            </button>
          </div>
          {!facilityGroupsLoading && facilityGroups ? (
            facilityGroups.facilityGroups.map((facilityGroup, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-start gap-6 md:w-full"
                >
                  <div className="flex gap-2 items-center">
                    <span className="font-semibold text-neutral-500">
                      {facilityGroup.name}
                    </span>
                  </div>
                  <div className="flex flex-col items-start gap-4 flex-1 text-neutral-800 md:grid md:grid-cols-2 md:w-full">
                    {boatFacilities?.boatFacilities.map(
                      facility =>
                        facility.facilityGroupId ==
                          facilityGroup.facilityGroupId && (
                          <div className="flex items-center gap-2">
                            {IconMapper(facility.iconName ?? '', 20)}
                            <span>{facility.name}</span>
                          </div>
                        ),
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <Skeleton variant="rectangular" width={366} height={422} />
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <button
          className="flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800"
          onClick={() => setShowBoatFacilities(false)}
        >
          <span className="font-semibold">Close</span>
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default BoatFacilityDialog;
